import {
  CONTENT_EVENTGUIDE_LIST,
  LOAD_EDIT_EVENTGUIDE_DATA,
  OPEN_EVENTGUIDE_MODAL,
  EVENTGUIDE_MAX_DISPLAYORDER,
  UPDATE_EVENTGUIDE_FILES,
  EVENTGUIDE_FILES_CHANGED,
  CONTENT_CATEGORY_LIST,
  UPDATE_VARIATION_FILES,
} from "ActionsEventguide";

import { FETCH_ADVERTISEMENTS } from "ActionsAdvertisement";

export function advertisementsList(state = [], action) {
  switch (action.type) {
    case FETCH_ADVERTISEMENTS:
      return action.payload;
    default:
      return state;
  }
}

// Event Guide Category List
export function CategoryList(state = [], action) {
  switch (action.type) {
    case CONTENT_CATEGORY_LIST:
      return action.payload;
    default:
      return state;
  }
}

// EVENTGUIDE LIST STORE
export function EventGuideList(state = [], action) {
  switch (action.type) {
    case CONTENT_EVENTGUIDE_LIST:
      return action.payload;
    default:
      return state;
  }
}

// Get max DISPLAYORDER number
export function GetMaxDisplayorderEventGuide(state = [], action) {
  switch (action.type) {
    case EVENTGUIDE_MAX_DISPLAYORDER:
      return action.payload;
    default:
      return state;
  }
}

export function OpenEventGuideModal(state = [], action) {
  switch (action.type) {
    case OPEN_EVENTGUIDE_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function LoadEditeventguidesData(state = {}, action) {
  switch (action.type) {
    case LOAD_EDIT_EVENTGUIDE_DATA:
      return action.payload;
    default:
      return state;
  }
}

// List Of 10 Files from file1-file10
export function eventguidefilesList(
  state = [
    { position: "file1", file: "", filename: "" },
    { position: "file2", file: "", filename: "" },
    { position: "file3", file: "", filename: "" },
    { position: "file4", file: "", filename: "" },
    { position: "file5", file: "", filename: "" },
    { position: "file6", file: "", filename: "" },
    { position: "file7", file: "", filename: "" },
    { position: "file8", file: "", filename: "" },
    { position: "file9", file: "", filename: "" },
    { position: "file10", file: "", filename: "" },
  ],
  action
) {
  switch (action.type) {
    case UPDATE_EVENTGUIDE_FILES:
      return action.payload;
    default:
      return state;
  }
}

// Event Guide File Change
export function eventguidefilesChanged(state = { ischanged: false }, action) {
  switch (action.type) {
    case EVENTGUIDE_FILES_CHANGED:
      return action.payload;
    default:
      return state;
  }
}

// List Of 5 Files from file1-file10
export function variationsfilesList(
  state = [
    { position: "file1", file: "", filename: "" },
    { position: "file2", file: "", filename: "" },
    { position: "file3", file: "", filename: "" },
    { position: "file4", file: "", filename: "" },
    { position: "file5", file: "", filename: "" },
  ],
  action
) {
  switch (action.type) {
    case UPDATE_VARIATION_FILES:
      return action.payload;
    default:
      return state;
  }
}
